
import LocalDataService from "@/service/LocalDataService";
import { nurseryModule } from "@/store/dataModule/nurseryModule";
import { OperationNurseryResponse } from "chaild-api/lib";
import Vue from "vue";

export default Vue.extend({
  async mounted() {
    await this.listNurseries();
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    nurseries: function (): OperationNurseryResponse[] {
      return nurseryModule.nurseries;
    },
  },

  methods: {
    async listNurseries() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await nurseryModule.listNurseries({
          companyId: companyId,
        });
      }
      this.isLoading = false;
    },
    create() {
      this.$router.push({ name: "SchoolDetailSetting" });
    },
  },
});
